
import axios from 'axios';
import { APIUrls } from '../constant/constant';
const ACCESS_TOKEN_KEY = process.env.REACT_APP_ACCESS_TOKEN_KEY || 'auth_access';
const REFRESH_TOKEN_KEY = process.env.REACT_APP_REFRESH_TOKEN_KEY || 'auth_refresh';


export const tokenStore = {
  getAccess: () => localStorage.getItem(ACCESS_TOKEN_KEY),
  setAccess: (t) => t ? localStorage.setItem(ACCESS_TOKEN_KEY, t) : localStorage.removeItem(ACCESS_TOKEN_KEY),
  getRefresh: () => localStorage.getItem(REFRESH_TOKEN_KEY),
  setRefresh: (t) => t ? localStorage.setItem(REFRESH_TOKEN_KEY, t) : localStorage.removeItem(REFRESH_TOKEN_KEY),
  clear: () => { localStorage.removeItem(ACCESS_TOKEN_KEY); localStorage.removeItem(REFRESH_TOKEN_KEY); }
};

export const axiosClient = axios.create({
  baseURL: APIUrls.BASE_URL,
  timeout: 20000,
  headers: { 'Content-Type': 'application/json' }
});

axiosClient.interceptors.request.use(config => {
  const tok = tokenStore.getAccess();
  if (tok) config.headers.Authorization = `Bearer ${tok}`;
  return config;
});

let isRefreshing = false;
let queue = [];

function flushQueue(error, accessToken) {
  queue.forEach(({ resolve, reject, config }) => {
    if (error) return reject(error);
    if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
    resolve(axiosClient.request(config));
  });
  queue = [];
}

async function callRefresh() {
  const refreshToken = tokenStore.getRefresh();
  if (!refreshToken) throw new Error('No refresh token');
  const url = `${APIUrls.BASE_URL}${process.env.REACT_APP_REFRESH_PATH || '/auth/refresh'}`;
  const res = await axios.post(url, { refreshToken }, { headers: { 'Content-Type': 'application/json' } });
  const accessToken = res?.data?.accessToken ?? res?.data?.token;
  const newRefresh  = res?.data?.refreshToken ?? refreshToken;
  if (!accessToken) throw new Error('Refresh failed');
  tokenStore.setAccess(accessToken);
  tokenStore.setRefresh(newRefresh);
  return accessToken;
}

axiosClient.interceptors.response.use(
  r => r,
  async (error) => {
    const status = error?.response?.status;
    const original = error?.config;
    if (status !== 401 || !original || original._retry) {
      if (status === 401) tokenStore.clear();
      throw error;
    }
    original._retry = true;

    if (!isRefreshing) {
      isRefreshing = true;
      try {
        const newAccess = await callRefresh();
        isRefreshing = false;
        flushQueue(null, newAccess);
        original.headers.Authorization = `Bearer ${newAccess}`;
        return axiosClient.request(original);
      } catch (e) {
        isRefreshing = false;
        tokenStore.clear();
        flushQueue(e, null);
        throw e;
      }
    }
    return new Promise((resolve, reject) => queue.push({ resolve, reject, config: original }));
  }
);